@if (content().tabs) {
  <section>
    @if (content().teaserTitle !== '') {
      <h3 class="font-headline-small">
        {{ content().teaserTitle }}
      </h3>
    }
    @if (content().teaserText !== null) {
      <div class="pr-medium-b" [innerHTML]="content().teaserText | finSafe: 'html'"></div>
    }

    <div role="tablist" class="tablist">
      @for (tab of content().tabs; track $index) {
        <div class="tab flex flex--column flex--align-stretch">
          <fcom-button
            [text]="tab.title"
            [aria]="{
              selected: currentTab() === tab,
              controls: 'panel-' + tab.content.segment,
              role: 'tab',
            }"
            [removeFromNavigation]="currentTab() === tab"
            [theme]="currentTab() === tab ? ButtonTheme.SECONDARY_OUTLINE : ButtonTheme.TERTIARY_GHOST"
            [id]="'tab-' + tab.content.segment"
            (click)="selectTab(tab)"
          />
        </div>
      }
    </div>

    @for (tab of content().tabs; track $index) {
      <div
        tabindex="0"
        role="tabpanel"
        [id]="'panel-' + tab.content.segment"
        [class.is-hidden]="currentTab() !== tab"
        [attr.aria-labelledby]="'tab-' + tab.content.segment"
        [attr.aria-hidden]="currentTab() !== tab"
      >
        <fin-cms-json-content [template$]="{ main: [tab.content] } | finToObservable" />
      </div>
    }
  </section>
}
